module.exports = __webpack_public_path__ + "static/media/speciality.2bfc0185.svg";